namespace Client.Domain

open Browser
open Fable.FontAwesome
open Fable.React
open Fable.React.Props
open Fulma

type Loadable<'a, 'b> =
    | Loading of 'b
    | Data of 'a
    | Error of string

[<RequireQualifiedAccess>]
module Loadable =
    let private wrapper (content: ReactElement list) =
        div [ ClassName "loading-view" ] content

    let loadingView maybeText size =
        let spinner = Fa.i [ Fa.Solid.CircleNotch; Fa.Spin; Fa.Size size ] []

        let content =
            match maybeText with
            | Some text -> [ spinner; Heading.h1 [] [ str text ] ]
            | None -> [ spinner ]

        wrapper content

    let errorView message =
        let heading = Heading.h3 [ Heading.CustomClass "m-3" ] [ str message ]

        let button =
            Button.button [
                Button.IsLink
                Button.OnClick(fun _ -> window.location.reload true)
            ] [ span [] [ str "Webseite neu laden" ] ]

        wrapper [ heading; button ]

    let view f (loadable: Loadable<'a, 'b>) : ReactElement =
        match loadable with
        | Loadable.Loading _ -> loadingView None Fa.Fa6x
        | Loadable.Data data -> f data
        | Loadable.Error message -> errorView message

    let listView f (loadable: Loadable<'a, 'b>) : ReactElement list =
        match loadable with
        | Loadable.Loading _ -> [ loadingView None Fa.Fa6x ]
        | Loadable.Data data -> f data
        | Loadable.Error message -> [ errorView message ]

    let toOption (loadable: Loadable<_, _>) =
        match loadable with
        | Loadable.Data data -> Some data
        | _ -> None